import React from 'react';
import actions from '../actions/ChangeUserPasswordAction';
import { withRouter } from 'react-router-dom';
var trstyle = {
    float: 'right',
    margin: '10px 15px 0px 0px'
}
class ChangeUserPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            oldPssword: '',
            inputPassword: '',
            confirmPassword: '',
        };
    }

    savePasswordInfo(e) {
        e.preventDefault();
        actions.saveChangePassword(this.state);
        this.props.history.push('/Login')
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    render() {
        return (
            <div data-page="form" className="page no-toolbar no-navbar">
                <div className="page-content">
                    <div className="navbarpages navbarpagesbg">
                        <div className="navbar_left">
                            <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                        </div>
                    </div>
                    <div id="pages_maincontent">
                        <h3 style={{ 'color': '#0000FF' }}><b style={{ 'padding-left': '100px' }}>पासवर्ड बदला </b></h3>
                        <div className="page_single layout_fullwidth_padding">
                            <div className="contactform">
                                <form className="" id="CustomForm" method="post" action="">
                                    <div className="form_row custom_select">
                                        <a href=" " className="item-link smart-select" data-open-in="picker">
                                            <div className="item-content">
                                                <div className="item-inner">
                                                    <label htmlFor="oldPssword">जुना पासवर्ड टाका :</label>
                                                    <input className="form_input" type="password" id="oldPssword" name="oldPssword" value={this.state.oldPssword} onChange={(e) => this.handleInputChange(e)} placeholder="जुना  पासवर्ड टाका" />
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="inputPassword">नवीन पासवर्ड टाका :</label>
                                                    <input className="form_input" type="password" data-minlength="6" id="inputPassword" name="inputPassword" value={this.state.inputPassword} onChange={(e) => this.handleInputChange(e)} placeholder="नवीन पासवर्ड टाका" />
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="confirmPassword">नवीन Confirm पासवर्ड टाका :</label>
                                                    <input type="password" className="form_input" id="confirmPassword" name="confirmPassword" onkeypress="checkPasswordMatch();" value={this.state.confirmPassword} onChange={(e) => this.handleInputChange(e)} placeholder="नवीन Confirm पासवर्ड टाका" />
                                                </div>
                                                <div className="registrationFormAlert" id="divCheckPasswordMatch"></div>
                                                <div className="form_row">
                                                    <button type="button" style={trstyle} className="btn  btn-primary" onClick={(e) => this.savePasswordInfo(e)} >✔ Save करा </button>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
export default withRouter(ChangeUserPassword)


// WEBPACK FOOTER //
// ./src/component/ChangeUserPassword.jsx